import React from 'react';
import Home from "./Home";
import Connect from './Connect';
import Products from "./Products";
import Features from './Features';
import Connect2 from './Connect2';

const Face = () => {;
    return (
        <>
            <Home />
            <Connect />
            <Products />
            <Features />
            <Connect2 />
        </>
    );
};

export default Face;